import React, { useState, useEffect, useRef } from 'react';
import { getRequest, postRequest } from '../../globalhelper/helper';
import { connect } from 'react-redux';
import {
    Autocomplete,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Box,
    Pagination,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Snackbar,
    Switch
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import store from '../../store';
import { hideLoader, showLoader } from '../../redux/Common/commonActions';

const Theme = (props) => {
    const textFields = [
        'targetfeildname',
        'sourcefieldname',
        'lde',
        'sourcefieldfunction',
        'dataformat',
        'targetfeild'
    ];

    const selectFeilds = ['targetfieldname', 'targetfielddatatype']

    const mandatoryFields = [
        'productcode',
        'processcode',
        'themename',
        'targetfeild',
        'targetfeildname',
        'targetfieldname',
        'targetfielddatatype'
    ];


    const [formData, setFormData] = useState({
        module: '',
        process: '',
        theme: '',
    });
    const [themeData, setThemeData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [moduleList, setModuleList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [themeList, setThemeList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [editIndex, setEditIndex] = useState(null);
    const [editRowData, setEditRowData] = useState({});
    const [selectOptions, setSelectOptions] = useState([]);
    const [isCreatingTheme, setIsCreatingTheme] = useState(false);
    const [isSavingTheme, setIsSavingTheme] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);
    const [editConfirmOpen, setEditConfirmOpen] = useState(false);
    const [rowToEdit, setRowToEdit] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [filterColumn, setFilterColumn] = useState(null);
    const [filterValue, setFilterValue] = useState(null);
    const timeoutRef = useRef(null);

    const handleAddRow = () => {
        const newRow = {};
        if (themeData.length > 0) {
            Object.keys(themeData[0]).forEach(key => {
                if (key === 'createddate') newRow[key] = new Date().toLocaleString();
                else if (key === 'mandatory') newRow[key] = 'false';
                else if (key === 'productcode') newRow[key] = themeData[0]?.productcode || formData?.module?.shortkey || '';
                else if (key === 'processcode') newRow[key] = themeData[0]?.processcode || formData?.process?.process_cd || '';
                else if (key === 'themename') newRow[key] = themeData[0]?.themename || (typeof formData?.theme === 'string' ? formData.theme : formData?.theme?.themename) || '';
                else newRow[key] = "";
            });
        }
        setThemeData(prevData => {
            let updatedData = [...prevData];
            if (editIndex !== null) {
                updatedData[editIndex] = editRowData;
            }
            return [newRow, ...updatedData];
        });
        setEditIndex(0);
        setEditRowData(newRow);
        setPage(0);
    };

    const handleCreateTheme = () => {
        setIsCreatingTheme(true);
        const newRow = {
            productcode: formData?.module?.shortkey || '',
            processcode: formData?.process?.process_cd || '',
            themename: typeof formData?.theme === 'string' ? formData.theme : formData?.theme?.themename || '',
            targetfieldname: '',
            createddate: new Date().toLocaleString(),
            targetfielddatatype: '',
            lde: '',
            sourcefieldname: '',
            mandatory: 'false',
            sourcefieldfunction: '',
            dataformat: ''
        };
        setThemeData([newRow]);
        setLoaded(true);
        setEditIndex(0);
        setEditRowData(newRow);
        setPage(0);
    };

    const handleDeleteTheme = () => {
        setIsCreatingTheme(false);
        setThemeData([]);
        setFormData({ ...formData, theme: '' });
    };

    const handleSaveTheme = () => {
        setIsSavingTheme(true);
        let dataToSave = themeData;
        if (editIndex !== null) {
            dataToSave = [...themeData];
            dataToSave[editIndex] = editRowData;
        }
        postRequest('api/module/saveTheme', { themeData: dataToSave, module: formData?.module?.shortkey }).then((res) => {
            console.log('Saved theme', res);
            setIsSavingTheme(false);
            setIsCreatingTheme(false);
            setThemeData([]);
            setFormData({ ...formData, theme: '' });
            setEditIndex(null);
            setEditRowData({});
        }).catch((err) => {
            console.error('Error saving theme', err);
            setIsSavingTheme(false);
        });
    };

    const handleEditRow = (index, row) => {
        if (editIndex !== null && editIndex !== index) {
            setThemeData(prevData => {
                const newData = [...prevData];
                newData[editIndex] = editRowData;
                return newData;
            });
        }
        setEditIndex(index);
        setEditRowData(row);
    };

    const handleSaveRow = (index) => {
        if (!isCreatingTheme) {
            setRowToEdit({ index, row: editRowData });
            setEditConfirmOpen(true);
        } else {
            setThemeData(prevData => {
                const newData = [...prevData];
                newData[index] = editRowData;
                return newData;
            });
            setEditIndex(null);
        }
    };

    const confirmEditRow = () => {
        setEditConfirmOpen(false);
        postRequest('api/module/editThemeRow', rowToEdit.row).then((res) => {
            console.log('Row updated', res);
            setThemeData(prevData => {
                const newData = [...prevData];
                newData[rowToEdit.index] = rowToEdit.row;
                return newData;
            });
            setEditIndex(null);
            setRowToEdit(null);
        }).catch(err => {
            console.error('Error updating row', err);
            setRowToEdit(null);
        }).finally(async () => {
            await getProcessDefn(...formData, formData.theme?.themename)
        });
    };

    const cancelEditRow = () => {
        setEditConfirmOpen(false);
        setRowToEdit(null);
    };

    const handleDeleteRow = (index) => {
        setRowToDelete({ index, row: themeData[index] });
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        setDeleteConfirmOpen(false);
        const newData = themeData.filter((_, i) => i !== rowToDelete.index);
        setThemeData(newData);

        if (!isCreatingTheme) {
            setSnackbarOpen(true);
            timeoutRef.current = setTimeout(() => {
                postRequest('api/module/deleteThemeRow', rowToDelete.row).then((res) => {
                    console.log('Deleted row successfully', res);
                }).finally(async () => {
                    await getProcessDefn(...formData, formData.theme?.themename);
                    await onProcessChange(formData?.module?.shortkey)
                });
                setSnackbarOpen(false);
                setRowToDelete(null);
            }, 15000);
        } else {
            setRowToDelete(null);
        }
    };

    const undoDelete = () => {
        clearTimeout(timeoutRef.current);
        setSnackbarOpen(false);
        const newData = [...themeData];
        newData.splice(rowToDelete.index, 0, rowToDelete.row);
        setThemeData(newData);
        setRowToDelete(null);
    };

    const cancelDeleteDialog = () => {
        setDeleteConfirmOpen(false);
        setRowToDelete(null);
    };

    const handleCancelEdit = (index) => {
        setEditIndex(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChange = (name, value, event) => {
        console.log(name, value);

        const newFormData = {
            ...formData,
            [name]: value,
        };
        setFormData(newFormData);
    };

    const getModule = () => {
        getRequest('api/admin/getAll_Modules').then((response) => {
            if (response.res.status === 'success') {
                const sortedProduct = response.res.data
                    .filter((item) => item.name !== null && item.name !== undefined)
                    .sort((a, b) => a.name.localeCompare(b.name));
                setModuleList(sortedProduct);
            }
        });
    };

    useEffect(() => {
        getModule();
    }, []);

    const onModuleChange = (Module) => {
        getRequest(`api/module/getProcessForModulesFromPG?shortkey=${Module.shortkey}`).then((response) => {
            if (response.res.status === 'success') {
                setProcessList(response.res.data);
                const uniqueTargetFieldNames = [...new Set(response.res.data.map((item) => item.targetfieldname))];
                const uniqueTargetFieldTypes = [...new Set(response.res.data.map((item) => item.targetfieldtype))];
                setSelectOptions((prev) => ({
                    ...prev,
                    targetfieldname: uniqueTargetFieldNames,
                    targetfielddatatype: uniqueTargetFieldTypes,
                }));
            }
        });
    };

    const onProcessChange = (process_code) => {
        getRequest(
            'api/upload/getThemes?process_code=' + process_code + '&text=create&module=' + formData.module.shortkey
        ).then((res) => {
            if (res.type === 'success') {
                setThemeList(res.res.data);
                if (res.res.data.length === 1) {
                    setFormData((prev) => ({
                        ...prev,
                        theme: res.res.data[0].theme
                    }));
                    getProcessDefn({
                        ...formData,
                        theme: res.res.data[0].theme
                    });
                }
            }
        });
    };

    const getProcessDefn = async (currentFormData, theme) => {
        console.log(currentFormData);

        try {
            setLoaded(false);
            store.dispatch(showLoader());
            if (currentFormData.process !== null && theme) {
                getRequest(`api/module/getThemeFromPG?process_name=${currentFormData?.process?.process_cd}&module=${currentFormData?.module?.shortkey}&themeName=${theme}`).then((response) => {
                    if (response.res.status === 'success') {
                        setThemeData(response.res.data);
                        console.log(response.res.data);
                    }
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoaded(true);
            store.dispatch(hideLoader());
        }
    };

    const isSaveDisabled = () => {
        if (!themeData || themeData.length === 0) return true;

        let dataToValidate = [...themeData];
        if (editIndex !== null) {
            dataToValidate[editIndex] = { ...dataToValidate[editIndex], ...editRowData };
        }

        for (let row of dataToValidate) {
            for (let field of mandatoryFields) {
                if (Object.keys(row).includes(field)) {
                    if (row[field] === null || row[field] === undefined || String(row[field]).trim() === '') {
                        return true;
                    }
                }
            }
        }
        return false;
    };

    const filteredThemeData = (!filterColumn || filterValue === null || filterValue === undefined) ? themeData : themeData.filter(row => row[filterColumn] === filterValue);
    const filterOptions = themeData.length > 0 ? Object.keys(themeData[0]) : [];
    const filterValueOptions = filterColumn ? [...new Set(themeData.map(row => row[filterColumn]))].filter(Boolean) : [];

    return (
        <>
            <Grid
                container
                spacing={2}>
                <Grid
                    item
                    xs={4}
                    className="text-center">
                    <Autocomplete
                        size="small"
                        fullWidth
                        value={formData?.module?.shortkey}
                        options={moduleList}
                        getOptionLabel={(option) => option?.name || ''}
                        isOptionEqualToValue={(option, value) => option.shortkey === value?.shortkey}
                        onChange={(event, newValue) => {
                            handleChange('module', newValue, event);
                            if (newValue) {
                                onModuleChange(newValue);
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                size="small"
                                {...params}
                                label="Module"
                                variant="outlined"
                                id="module"
                                name="module"
                            />
                        )}
                    />
                </Grid>
                <Grid
                    xs={4}
                    item
                    className="text-center">
                    <Autocomplete
                        size="small"
                        fullWidth
                        value={formData.process}
                        options={processList}
                        getOptionLabel={(option) => option?.process_name || ''}
                        isOptionEqualToValue={(option, value) => option?.process_cd === value?.process_cd}
                        onChange={(event, newValue) => {
                            handleChange('process', newValue, event);
                            if (newValue)
                                onProcessChange(newValue?.process_cd);
                        }}
                        renderInput={(params) => (
                            <TextField
                                size="small"
                                {...params}
                                label="Process"
                                variant="outlined"
                                id="process"
                                name="process"
                            />
                        )}
                    />
                </Grid>
                <Grid
                    xs={4}
                    item
                    className="text-center">
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {isCreatingTheme ? (
                            <TextField
                                size="small"
                                fullWidth
                                label="Theme"
                                variant="outlined"
                                value={typeof formData.theme === 'string' ? formData.theme : formData.theme?.themename || ''}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setFormData({ ...formData, theme: val });
                                    setThemeData(prevData => prevData.map(row => ({
                                        ...row,
                                        themename: val
                                    })));
                                    setEditRowData(prev => Object.keys(prev).length > 0 ? { ...prev, themename: val } : prev);
                                }}
                            />
                        ) : (
                            <Autocomplete
                                size="small"
                                fullWidth
                                value={formData.theme || null}
                                options={themeList}
                                getOptionLabel={(option) => typeof option === 'string' ? option : option?.themename || ''}
                                isOptionEqualToValue={(option, value) => typeof option === 'string' ? option === value : option?.themename === (typeof value === 'string' ? value : value?.themename)}
                                onChange={(event, newValue) => {
                                    handleChange('theme', newValue, event);
                                    if (newValue && typeof newValue !== 'string') {
                                        getProcessDefn({ ...formData, theme: newValue }, newValue?.themename);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        size="small"
                                        {...params}
                                        label="Theme"
                                        variant="outlined"
                                        id="theme"
                                        name="theme"
                                    />
                                )}
                            />
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCreateTheme}
                            startIcon={<AddIcon />}
                            disabled={!formData?.module || !formData?.process}
                        >
                            Create
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleDeleteTheme}
                            startIcon={<DeleteIcon />}
                            disabled={!formData?.theme}
                        >
                            Delete
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            {(loaded && themeData.length > 0) && (<>
                <Box sx={{ m: 2, display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row" }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddRow}>
                            Add Row
                        </Button>
                        {isCreatingTheme && (
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSaveTheme}
                                startIcon={<SaveIcon />}
                                disabled={isSavingTheme || isSaveDisabled()}
                            >
                                Save
                            </Button>
                        )}
                    </Box>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Autocomplete
                            size="small"
                            sx={{ width: 200 }}
                            value={filterColumn}
                            onChange={(e, newValue) => {
                                setFilterColumn(newValue);
                                setFilterValue(null);
                                setPage(0);
                            }}
                            options={filterOptions}
                            renderInput={(params) => <TextField {...params} label="Filter By Column" variant="outlined" />}
                        />
                        <Autocomplete
                            size="small"
                            sx={{ width: 200 }}
                            value={filterValue}
                            onChange={(e, newValue) => {
                                setFilterValue(newValue);
                                setPage(0);
                            }}
                            options={filterValueOptions}
                            disabled={!filterColumn}
                            renderInput={(params) => <TextField {...params} label="Filter Value" variant="outlined" />}
                        />
                    </Box>
                    <Pagination
                        count={Math.ceil(filteredThemeData.length / rowsPerPage)}
                        page={page + 1}
                        onChange={(event, newPage) => {
                            handleChangePage(event, newPage - 1);
                        }}
                        variant="outlined"
                        shape="rounded"
                        showFirstButton
                        showLastButton
                    />
                </Box>
                <TableContainer sx={{ mt: 2 }} component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                {Object.keys(themeData[0]).map((key) => (
                                    <TableCell key={key}>{key}</TableCell>
                                ))}
                                <TableCell sx={{ position: 'sticky', right: 0, backgroundColor: '#f5f5f5', zIndex: 2 }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? filteredThemeData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : filteredThemeData
                            ).map((row, index) => {
                                const originalIndex = themeData.indexOf(row);
                                const isEditing = editIndex === originalIndex;

                                return (
                                    <TableRow key={originalIndex}>
                                        {Object.keys(row).map((key, i) => (
                                            <TableCell key={i}>
                                                {isEditing && textFields.includes(key) ? (
                                                    <TextField
                                                        size="small"
                                                        value={editRowData[key] || ""}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            setEditRowData(prev => ({ ...prev, [key]: val }));
                                                        }}
                                                        variant="outlined"
                                                        sx={{ width: "100px" }}
                                                        required={mandatoryFields.includes(key)}
                                                    />
                                                ) : isEditing && selectFeilds.includes(key) ?
                                                    <Autocomplete
                                                        size="small"
                                                        value={editRowData[key] ? editRowData[key] : null}
                                                        options={selectOptions?.[key] || []}
                                                        onChange={(event, newValue) => {
                                                            setEditRowData(prev => ({ ...prev, [key]: newValue }));
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                sx={{ width: "200px" }}
                                                                size="small"
                                                                {...params}
                                                                label={key}
                                                                variant="outlined"
                                                                id={key}
                                                                name={key}
                                                            />
                                                        )}
                                                    />
                                                    : key === 'mandatory' ? (
                                                        <Switch
                                                            size="small"
                                                            checked={editRowData[key] === 'true'}
                                                            onClick={(e) => {
                                                                if (isEditing && editRowData[key]) setEditRowData({ ...editRowData, [key]: editRowData[key] === 'false' ? 'true' : 'false' })
                                                            }}
                                                        />
                                                    ) : (
                                                        isEditing ? (editRowData[key] || "") : row[key]
                                                    )}
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ whiteSpace: "nowrap", position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1, borderLeft: '1px solid #e0e0e0' }}>
                                            {isEditing ? (
                                                <>
                                                    <IconButton
                                                        color="success"
                                                        onClick={() => handleSaveRow(originalIndex)}
                                                        size="small"
                                                        disabled={mandatoryFields.some(field => Object.keys(row).includes(field) && !editRowData[field])}
                                                    >
                                                        <SaveIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton color="default" onClick={() => handleCancelEdit(originalIndex)} size="small">
                                                        <CancelIcon fontSize="small" />
                                                    </IconButton>
                                                </>
                                            ) : (
                                                <>
                                                    <IconButton color="primary" onClick={() => handleEditRow(originalIndex, row)} size="small">
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton color="error" onClick={() => handleDeleteRow(originalIndex)} size="small">
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>)}

            {/* Edit Confirmation Dialog */}
            <Dialog open={editConfirmOpen} onClose={cancelEditRow}>
                <DialogTitle>Confirm Edit</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to save changes to this row?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelEditRow} color="error">
                        No
                    </Button>
                    <Button onClick={confirmEditRow} color="success" variant="contained">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteConfirmOpen} onClose={cancelDeleteDialog}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this row?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Undo Delete Snackbar */}
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={() => setSnackbarOpen(false)}
                message="Row deleted."
                action={
                    <Button color="secondary" size="small" onClick={undoDelete}>
                        UNDO
                    </Button>
                }
            />
        </>
    );
};

function mapStateToProps(state) {
    return {
        state
    };
}

export default connect(mapStateToProps)(Theme);